Object.defineProperty(exports, "__esModule", { value: true });
exports.inputObjectTypeRegistry = void 0;
exports.inputObjectTypeRegistry = new WeakMap();
//# sourceMappingURL=registry.js.map